import './styles/App.css';
import Navbar from "./components/Navbar"
import Meme from './components/Meme';

function App() {
  return (
    <div className="app">
      <Navbar />
      <Meme />
    </div>
  );
}

export default App;
